import { ApolloProvider } from "@apollo/client";
import React, { FC, PropsWithChildren } from "react";

import client from "./client";

const GraphQLProvider: FC<PropsWithChildren<{}>> = ({ children }) => (
  <ApolloProvider client={client}>{children}</ApolloProvider>
);

export default GraphQLProvider;
